<template>
    <div>
        <div class="row">
            <div class="col-sm-6">
                <div class="panel panel-default">
                    <div class="panel-body text-center">
                        <p class="fa-2x">
                            Excel
                        </p>
                        <i class="fad fa-file-excel fa-5x aristotle-font-awesome-duotone" />
                    </div>
                    <div class="panel-footer text-center">
                        <div class="row">
                            <div class="col-md-6">
                                <form method="get" :action="excelTemplateFilePath">
                                    <button type="submit" class="button btn btn-default">
                                        Download Template
                                    </button>
                                </form>
                            </div>
                            <div class="col-md-6">
                                <form method="get" :action="excelExampleFilePath">
                                    <button type="submit" class="button btn btn-default">
                                        Download Example
                                    </button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-sm-6">
                <div class="panel panel-default">
                    <div class="panel-body text-center">
                        <p class="fa-2x">
                            CSV
                        </p>
                        <i class="fad fa-file-csv fa-5x aristotle-font-awesome-duotone" />
                    </div>
                    <div class="panel-footer text-center">
                        <div class="row">
                            <div class="col-md-6">
                                <form method="get" :action="csvTemplateFilePath">
                                    <button class="button btn btn-default">
                                        Download Template
                                    </button>
                                </form>
                            </div>
                            <div class="col-md-6">
                                <form method="get" :action="csvExampleFilePath">
                                    <button class="button btn btn-default">
                                        Download Example
                                    </button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="text-center">
            Learn more and see examples on the
            <a href="https://labs.aristotlemetadata.com/#/sddf">
                Simple Data Dictionary Format
                specification page.
            </a>
        </div>
    </div>
</template>

<script>
export default {
    name: "SddfTemplates",
    props: {
        excelTemplateFilePath: {
            type: String,
            default: '',
        },
        excelExampleFilePath: {
            type: String,
            default: '',
        },
        csvTemplateFilePath: {
            type: String,
            default: '',
        },
        csvExampleFilePath: {
            type: String,
            default: '',
        },
    },
}
</script>

<style scoped>

</style>
